module.exports = __webpack_public_path__ + "img/whatsapp-call-w.3d76bc6b.svg";